import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-munaseeb',
  templateUrl: './munaseeb.component.html',
  styleUrls: ['./munaseeb.component.scss']
})
export class MunaseebComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
